
export const updateMentors = (options) => {
  return (dispatch, getState) => {
    const { organization, resident } = getState()
    $.ajax({
      url: `/organizations/${organization.name}/mentorships/update_all.json?by_resident=${resident.id}`,
      method: 'POST',
      data: {
        mentor_ids: options.map(option=>option.value)
      },
      success: (mentorIds) => {
        dispatch({ type: "UPDATE_RESIDENT", payload: { name: 'mentor_ids', value: mentorIds }})
      },
    })
  }
}